// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Playfair Display', 'Playfair Display Fallback'","fontStyle":"normal"},"className":"__className_145703","variable":"__variable_145703"};